import { Stack, Typography } from '@mui/material'

import { PriceActiveLine, PriceProductCart, PriceProductCartTotal } from '@/components/ProductPrice/ProductPrice.styled'
import { PriceLabelEnum } from '@/enums/PriceLabelEnum'
import { getPriceMarkers } from '@/helpers/getPriceMarkers'
import { useTenant } from '@/hooks/useTenant'
import { useTranslations } from '@/hooks/useTranslations'
import { commerceTheme as theme } from '@/themes/commerce/theme'

import type React from 'react'
import type { getBffPrices } from '@/helpers/getBffPrices'

interface Props {
  price?: ReturnType<typeof getBffPrices>
  isLoading?: boolean
}
export const CartTotalPrice: React.FC<Props> = ({ price, isLoading = false }) => {
  const { translate } = useTranslations()
  const tenant = useTenant()

  const { totalPrice, totalFullPrice, totalFullPriceFromQuantity } = getPriceMarkers(
    price ?? null,
    tenant.currency,
    tenant.locale
  )

  return (
    <Stack sx={{ width: '100%', textAlign: 'right' }}>
      <>
        {isLoading ? (
          <Stack>
            <PriceProductCartTotal />
            <PriceProductCart />
          </Stack>
        ) : (
          <>
            {totalFullPrice == null && totalFullPriceFromQuantity == null && totalPrice ? (
              <Typography variant="body2">{translate('cart.orderSummary.totalPrice')}</Typography>
            ) : (
              <Typography component="p" sx={{ color: theme.palette.text.placeholder, marginLeft: 0.5 }} variant="body2">
                {translate(`productDetails.listPrice`)}
                <Typography component="span" sx={{ textDecoration: 'line-through' }}>
                  {totalFullPrice ?? totalFullPriceFromQuantity}
                </Typography>
              </Typography>
            )}
            <PriceActiveLine
              sx={{
                color:
                  totalFullPrice || price?.priceType === PriceLabelEnum.CAMPAIGN
                    ? theme.palette.text.campaignPrice
                    : theme.palette.text.primary,
              }}
              variant="body1"
            >
              {totalPrice}
            </PriceActiveLine>
          </>
        )}
      </>
    </Stack>
  )
}
